import { render, staticRenderFns } from "./diainfadi.vue?vue&type=template&id=1b705bed&scoped=true"
import script from "./diainfadi.vue?vue&type=script&lang=js"
export * from "./diainfadi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b705bed",
  null
  
)

export default component.exports